import React from 'react';
import { Card } from '@/components/ui/cards/Card';
import { Skeleton } from '@/components/ui/loading';
import { colors } from '@/assets/styles/colors';


interface AttendanceSituationCardSkeletonProps {
  'data-testid'?: string;
}

export const AttendanceSituationCardSkeleton: React.FC<AttendanceSituationCardSkeletonProps> = ({
  'data-testid': dataTestId,
}) => (
  <Card elevation={2} borderRadius="16px" padding="0" data-testid={dataTestId}>
    <div style={{ display: 'flex', alignItems: 'center', padding: '24px 32px', gap: 24 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
        <Skeleton
          size={{ width: 34, height: 31 }}
          className="rounded-full"
          data-testid={`${dataTestId}-status-dot`}
        />

        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Skeleton width={160} height={28} data-testid={`${dataTestId}-status-label`} />
          <Skeleton width={200} height={18} data-testid={`${dataTestId}-schedule-theoretical`} />
          <Skeleton width={200} height={18} data-testid={`${dataTestId}-schedule-real`} />
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        {[0, 1, 2].map((index) => (
          <React.Fragment key={index}>
            {index > 0 && (
              <div
                style={{
                  width: 4,
                  height: 93,
                  backgroundColor: colors.grays.neutralE5,
                  borderRadius: 2,
                  flexShrink: 0,
                }}
              />
            )}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: 8,
                padding: '0 32px',
                minWidth: 160,
              }}
              data-testid={`${dataTestId}-metric-${index}`}
            >
              <Skeleton width={60} height={40} data-testid={`${dataTestId}-metric-${index}-value`} />
              <Skeleton width={90} height={16} data-testid={`${dataTestId}-metric-${index}-label`} />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  </Card>
);

export default AttendanceSituationCardSkeleton;
